import { useQuery } from "react-query";
import {
  getFilteredProjects,
  getHomeBaseData,
  getProvidences
} from "../../services/api/api";

const homeApi = {
  fetchHomeBaseData: async () => {
    const { data } = await getHomeBaseData();
    return data;
  },

  fetchProvidences: async () => {
    const {data} = await getProvidences();
    return data;
  },

  fetchFilteredProjects: async (parsedSelectedStages, selectedProgress, pdcIds, clientIds, stateIds) => {
    // OTIMIZADO: String vazia em parsedSelectedStages = todas as etapas (não precisa filtrar)
    // Ainda precisa ter ao menos 1 filtro ou progress selecionado para executar
    const hasAnyFilter = 
      parsedSelectedStages !== "" || 
      (pdcIds && pdcIds.length > 0) || 
      (clientIds && clientIds.length > 0) || 
      (stateIds && stateIds.length > 0);

    if (hasAnyFilter || selectedProgress != undefined) {
      const { data } = await getFilteredProjects(
        selectedProgress.value,
        parsedSelectedStages,
        pdcIds,
        clientIds,
        stateIds
      );
      return data;
    }
    return [];
  },
};



export const useHomeBaseData = () => {
  const { isLoading: homeBaseDataLoading, data: homeBaseData } = useQuery(
    "homeBaseQuery",
    homeApi.fetchHomeBaseData,
    {
      staleTime: Infinity,
      retry: 5
    }
  );

  return {
    homeBaseDataLoading,
    homeBaseData,
  };
};



export const useFilteredProjects = (parsedSelectedStages, selectedProgress, pdcIds, clientIds, stateIds) => {
  const { isLoading: filteredProjectsLoading, data: filteredProjectsData } =
    useQuery(
      ["filteredProjectsQuery", [parsedSelectedStages, selectedProgress, pdcIds, clientIds, stateIds]],
      () =>
        homeApi.fetchFilteredProjects(parsedSelectedStages, selectedProgress, pdcIds, clientIds, stateIds),
      {
        staleTime: Infinity,
        retry: 5,
        enabled: selectedProgress != undefined, // Só executa se tiver status selecionado
      }
    );

  return {
    filteredProjectsLoading,
    filteredProjectsData,
  };
};


export const useProvidences = () => {
  const { isLoading: providencesLoading, data: providencesData } = useQuery(
    "providencesQuery",
    homeApi.fetchProvidences,
    {
      staleTime: Infinity,
      retry: 5
    }
  );

  return {
    providencesLoading,
    providencesData,
  };
};
